import { inject, Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { PageTitleService } from './page-title.service';

/**
 * Applica il `title` statico delle rotte (es. login) con il suffisso della suite.
 * Le pagine con titolo dinamico (tipologia, prodotto, sezione) non dichiarano `title` e lo impostano da sé.
 */
@Injectable()
export class PageTitleStrategy extends TitleStrategy {
  private readonly pageTitle = inject(PageTitleService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    if (title !== undefined) {
      this.pageTitle.set(title);
    }
  }
}
